import React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { NumericTextBox, NumericTextBoxFocusEvent } from '@progress/kendo-react-inputs';
import { EDITING_VIEW_FIELD, EMPTY_VALUE, MIN_FACETS_COUNT, MAX_FACETS_COUNT } from '@cs-cms/types';

export const EditableFacetsCountCell: React.FC<GridCustomCellProps> = props => {
  const field = props.field || EMPTY_VALUE;
  const value = props.dataItem[field];

  if (!props.dataItem.facetable) {
    return (
      <td
        className={props.className}
        style={props.style}
        colSpan={props.colSpan}
        role={'gridcell'}
        aria-colindex={props.ariaColumnIndex}
        aria-selected={props.isSelected}
        data-grid-col-index={props.columnIndex}
      >
        {value || ''}
      </td>
    );
  }

  const handleChange = (event: any): void => {
    if (!props.onChange) {
      return;
    }

    const newValue = event.value;

    const newEvent = {
      ...event,
      dataItem: props.dataItem,
      field,
      value: newValue,
      dataIndex: props.dataIndex
    };

    props.onChange(newEvent);
  };

  const handleFocus = (e: NumericTextBoxFocusEvent): void => {
    e.syntheticEvent.stopPropagation();
  };

  return (
    <td
      className={props.className}
      style={props.style}
      colSpan={props.colSpan}
      role={'gridcell'}
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      data-grid-col-index={props.columnIndex}
    >
      <NumericTextBox
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        min={MIN_FACETS_COUNT}
        max={MAX_FACETS_COUNT}
        spinners={true}
        format="#"
        style={{ width: '100%' }}
        required={props.dataItem[EDITING_VIEW_FIELD.FACETABLE]}
      />
    </td>
  );
};
